// MUI
import { CELL_FONT_SIZE, COMBINATED_CLASSES } from "@/Constants/tables";

// Helpers
import { getCellClassNameFn } from "@/Common/helpers/Tables";

// Components
import CustomCell from "@/Layouts/components/Tables/DataSmartTable/additional/CustomCell";

export const columnProps = {
	headerClassName: COMBINATED_CLASSES,
	flex: 1,
	cellClassName: getCellClassNameFn([], {}, {}),
	renderCell: ({ formattedValue, colDef }: any) => (
		<CustomCell 
			value={formattedValue} 
			hasTooltip 
			maxWith={colDef?.maxWidth || colDef?.computedWidth} 
			fontSize={CELL_FONT_SIZE} 
		/>
	),
};
